import { Row } from '@tanstack/react-table';
import { isEmpty } from 'radash';

import { ValidationState } from '@/components/core/validationState/ValidationState';
import { PublicationPopover } from '@/components/itemsList/action-column/actions';

interface ValidationStateCell<TData> {
    row: Row<any>;
}

const ValidationStateCell = <TData,>({ row }: ValidationStateCell<TData>) => {

    const hasWarnings = !isEmpty(row.original.validation_warnings__);
    const isCompliant = isEmpty(row.original.validation__) ;
    const isDirty = row.original.validation_dirty__ ;

    return (
        <div
            id={`row${row.id}-validation-state`}
            className={`tw-pr-2 tw-h-9 ${
                row.original.publishedAt__
                    ? 'tw-flex tw-items-center tw-justify-end tw-gap-4'
                    : 'tw-flex tw-justify-end'
            }`}
        >
            {row.original.publishedAt__ && (
                <div data-publication-badge>
                    <PublicationPopover item={row.original} />
                </div>
            )}
            <div className='tw-flex tw-items-center'>
                <ValidationState
                    hasWarnings={hasWarnings}
                    isCompliant={isCompliant}
                    isDirty= {isDirty}
                />
            </div>
        </div>
    );
};

export { ValidationStateCell };
